<div id="widget-toggle-container">
    <div id="wt-label">{{widget.name | translate}}</div>
    <p-inputSwitch styleClass="widget-toggle" [(ngModel)]="isEnabled"></p-inputSwitch>
</div>
